import { FormPagePropertyItemNumber } from 'backend';
import { FormPageInputData, NUMBER_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';

export const getNumberInputValue = (
  propertyItem: FormPagePropertyItemNumber,
  propertyItemElement: PropertyItemElement,
): FormPageInputData => {
  switch (propertyItem.inputFormat.inputType) {
    case NUMBER_PROPERTY_INPUT_TYPE.additionalText: {
      const numberElement = propertyItemElement.number;
      if (!(numberElement instanceof HTMLInputElement)) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'numberAdditionalText',
          number: numberElement.value,
        },
      };
    }
    case NUMBER_PROPERTY_INPUT_TYPE.attitudeScale: {
      const radioElements = propertyItemElement.radios;
      if (
        !Array.isArray(radioElements) ||
        radioElements.some(
          (element) =>
            !(element instanceof HTMLInputElement) || element.type !== 'radio',
        )
      ) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'numberAttitudeScale',
          number: (radioElements as HTMLInputElement[]).find(
            (element) => element.checked,
          )?.value,
        },
      };
    }
  }
};
